export default __webpack_public_path__ + "static/media/sunwdokuz7.629e2122.jpg";